export const BILLING_VAT_RATE_OPTIONS = [
  { value: "21", label: "21 %" },
  { value: "10", label: "10 %" },
  { value: "4", label: "4 %" },
  { value: "0", label: "0 %" },
  { value: "manual", label: "Importe manual / varios tipos" },
] as const;

export type BillingVatRate = (typeof BILLING_VAT_RATE_OPTIONS)[number]["value"];

function parseEuroCents(value: unknown): number | null {
  if (value === null || value === undefined || value === "") return null;
  const raw = String(value).trim();
  const normalized = raw.includes(",") ? raw.replace(/\./g, "").replace(",", ".") : raw;
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
  const [euros, decimals = ""] = normalized.split(".");
  const cents = Number(euros) * 100 + Number((decimals + "00").slice(0, 2));
  return Number.isSafeInteger(cents) ? cents : null;
}

/** Calculate VAT in cents, rounded half-up without floating-point arithmetic. */
export function calculateInvoiceVatAmount(base: unknown, rate: BillingVatRate): string | null {
  if (rate === "manual") return null;
  const baseCents = parseEuroCents(base);
  if (baseCents === null) return null;
  const rateBasisPoints = Number(rate) * 100;
  const taxCentsBig = (BigInt(baseCents) * BigInt(rateBasisPoints) + BigInt(5_000)) / BigInt(10_000);
  if (taxCentsBig > BigInt(Number.MAX_SAFE_INTEGER)) return null;
  const taxCents = Number(taxCentsBig);
  return `${Math.floor(taxCents / 100)}.${String(taxCents % 100).padStart(2, "0")}`;
}
